__turbopack_context__.v({
  "active": "bv1qaq_active",
  "aiBadge": "bv1qaq_aiBadge",
  "categoryBadge": "bv1qaq_categoryBadge",
  "divider": "bv1qaq_divider",
  "root": "bv1qaq_root",
});
